import { Controller } from "@hotwired/stimulus"

// This controller is used to manage single select filters with radioboxes.
export default class extends Controller {
  static get targets() {
    return ["button", "optionElement", "optionLabel", "option", "searchInput", "selectedOption", "selectedOptionLabel"]
  }

  static get values() {
    return { name: String, selected: String, filter: String }
  }

  connect() {
    this.render()
  }

  search() {
    let query = this.searchInputTarget.value.toLowerCase()
    if (query.length === 0) {
      this.optionElementTargets.forEach((option) => {
        option.classList.remove("d-none")
      })

      return
    }

    let optionSelector = this.targets.getSelectorForTargetName("option")
    let labelSelector = this.targets.getSelectorForTargetName("optionLabel")

    this.optionElementTargets.forEach((option) => {
      let input = option.querySelector(optionSelector)
      if (input.checked) {
        return
      } // We don't hide checked options regardless of search
      let labelText = option.querySelector(labelSelector).innerText.toLowerCase()

      if (labelText.includes(query)) {
        option.classList.remove("d-none")
      } else {
        option.classList.add("d-none")
      }
    })
  }

  apply(event) {
    const filterName = event.target.value
    const selectedOption = this.getSelectedOption(filterName)

    this.selectedValue = selectedOption.value
    this.nameValue = selectedOption.name

    this.render()
    this.dispatchFilterEvent()

    if (this.hasButtonTarget) {
      const dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)
      dropdown.hide()
    }
  }

  remove(event) {
    const filterNameAsString = event.params.name.toString()
    this.selectedValue = ""
    this.nameValue = filterNameAsString
    this.selectedOptionTarget.classList.add("d-none")
    this.dispatchFilterEvent()
  }

  render() {
    this.optionTargets.forEach((option) => {
      if (!this.hasSelectedValue) {
        option.checked = false
        return
      }

      option.checked = this.selectedValue.includes(option.value)
    })

    this.showSelectedFilters()
  }

  showSelectedFilters() {
    const filterName = this.filterValue
    const selectedOption = this.getSelectedOption(filterName)

    if (selectedOption) {
      const labelSelector = selectedOption.labels[0]

      this.selectedOptionLabelTarget.innerText = labelSelector.innerText
      this.selectedOptionTarget.classList.remove("d-none")
    }
  }

  dispatchFilterEvent() {
    this.dispatch("filter", { detail: { name: this.nameValue, value: this.selectedValue } })
  }

  getSelectedOption(filterName) {
    if (!filterName) return
    return this.optionTargets.find((radio) => radio.checked && radio.name === filterName)
  }
}
